import React, { Component } from "react";
import postscribe from "postscribe";
import "./Futures.css";
import Config from "../../../config/config";

class Softs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadedScripts: 0,
      totalScripts: 10,
    };
  }

  componentDidMount() {
    const scriptCallback = () => {
      this.setState((prevState) => {
        const newLoadedScripts = prevState.loadedScripts + 1;
        const isLoading = newLoadedScripts < prevState.totalScripts;

        // Notify parent when all scripts are loaded
        if (!isLoading && this.props.onLoadComplete) {
          this.props.onLoadComplete("softs");
        }

        return {
          loadedScripts: newLoadedScripts,
          loading: isLoading,
        };
      });
    };

    postscribe(
      "#cocoa",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Cocoa:ECO,ECO*1,ECO*2,ECO*3,ECO*4,ECO*5,ECO*6,ECO*7,ECO*8,ECO*9,ECO*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#coffee",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Coffee:EKC,EKC*1,EKC*2,EKC*3,EKC*4,EKC*5,EKC*6,EKC*7,EKC*8,EKC*9,EKC*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#cotton",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Cotton:ECT,ECT*1,ECT*2,ECT*3,ECT*4,ECT*5,ECT*6,ECT*7,ECT*8,ECT*9,ECT*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#lumber",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Lumber:LBS,LBS*1,LBS*2,LBS*3,LBS*4,LBS*5,LBS*6,LBS*7,LBS*8,LBS*9,LBS*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#sugar-11",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Sugar no. 11:ESB,ESB*1,ESB*2,ESB*3,ESB*4,ESB*5,ESB*6,ESB*7,ESB*8,ESB*9,ESB*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#sugar-16",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Sugar no. 16:ESF,ESF*1,ESF*2,ESF*3,ESF*4,ESF*5,ESF*6,ESF*7,ESF*8,ESF*9,ESF*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#gold",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Gold:GC,GC*1,GC*2,GC*3,GC*4,GC*5,GC*6,GC*7,GC*8,GC*9,GC*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#silver",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Silver:SI,SI*1,SI*2,SI*3,SI*4,SI*5,SI*6,SI*7,SI*8,SI*9,SI*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#sp500",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*S%26P%20500:ES,ES*1,ES*2,ES*3,ES*4,ES*5,ES*6,ES*7,ES*8,ES*9,ES*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#nasdaq",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Nasdaq:NQ,NQ*1,NQ*2,NQ*3,NQ*4,NQ*5,NQ*6,NQ*7,NQ*8,NQ*9,NQ*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <div
        className={`grid grid-cols-1 tablet:grid-cols-2 md:grid-cols-3 justify-items-center gap-y-6 tablet:gap-y-8 gap-x-2 tablet:gap-x-5 p-4 mt-6 tablet:p-6 max-w-[1400px] mx-auto ${
          loading ? "opacity-70" : ""
        }`}
      >
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="cocoa"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="coffee"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="cotton"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="lumber"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="sugar-11"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="sugar-16"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="gold"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="silver"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="sp500"
        ></div>
        <div
          className="w-full max-w-[400px] shadow-md rounded-xl"
          style={{ backgroundColor: Config.styles.surface }}
          id="nasdaq"
        ></div>
      </div>
    );
  }
}

export default Softs;
